module.exports = __webpack_public_path__ + "static/media/DSCF3097-Edit.97271669.jpg";